/*
 * Module for the Fund Home Index view
*/

rs.module("fund/home/index",

    [ "controls/data/grid" ],

    function (gridModule) {

        function initialize(backendUrls, jsSelectors, workflowsGridLrsApi) {

            if (workflowsGridLrsApi) {

                var workflowsSpinner = $.js(jsSelectors.workflowsSpinner);

                // Show the Workflows Spinner since this grid loads in the background
                workflowsSpinner.show();

                // On initialize, populate the Workflows Grid
                gridModule.update(
                    backendUrls.getWorkflowsGridData,
                    {},
                    workflowsGridLrsApi.agGridApi,
                    function done(gridUpdate) {
                    }
                ).always(function () {
                    workflowsSpinner.hide();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);